import { Component, ViewEncapsulation, OnInit } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { FormBuilder, Validators, FormControl } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import {
  DropdownModel, BreadCrumbModel, PageLoaderService,
  StepIndicatorService, BreadCrumbService
} from 'lib/ng2-sapmp/src/ui-components';
import { UtilityService, AdobeAnalyticsService } from './../../../../lib/ng2-sapmp/src/providers';
import { FanModel } from './../../../models/fan/fan.model';
import { SendSMSService } from './../send-sms.service';
import { MessageModel } from './../models/smsMessage.model';
import { ENV } from 'config';

declare var ENV_VAR: any;

@Component({
  templateUrl: './message.component.html',
  styleUrls: ['./message.component.scss'],
  providers: [AdobeAnalyticsService],
  encapsulation: ViewEncapsulation.None
})

export class MessageComponent implements OnInit {
  public pageJson: any;
  public messageForm: any;
  public showDropdown: boolean;
  public showError: boolean;
  public disableNext: boolean;
  public fanList: Array<any>;
  public fanNumber: FormControl;
  private allCtnSelectedFan;
  private ctnSelectedFan;
  private preselectValue;
  private savedMessage: MessageModel;

  constructor(private utilities: UtilityService,
    private breadcrumb: BreadCrumbService,
    private stepIndicator: StepIndicatorService,
    private router: Router,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private messageService: SendSMSService,
    private spinner: PageLoaderService,
    private adobeAnalyticsService: AdobeAnalyticsService,
    private utilityService: UtilityService) {

    this.savedMessage = messageService.getMessageModel();
    this.spinner.setPageLoaderStatus(false);
    this.stepIndicator.setCurrentStep('message');
    this.stepIndicator.setVisibility(true);
    this.fanNumber = new FormControl();
    //messageService.getPageJson().subscribe(json => {
      //if (json) {
        this.pageJson = this.route.snapshot.data.pageData.sendMessagemessage;
        this.pageJson = this.pageJson['messageJson'];
     //   messageService.fetchJSON(this.utilities.getEnvConfig().messageFormJson).subscribe(resObj => {
          this.pageJson['formGroups'].map((item, ind) => {
            return Object.assign(item, this.pageJson.formGroup1[ind]);
          });
          const formObj = {};
          this.pageJson.formGroup1.forEach(field => {
            const fieldValidator = [];
            if (field.validation) {
              const inputValidator = field.validation;
              if (inputValidator.required) {
                fieldValidator.push(Validators.required);
              }
              if (inputValidator.maxLength) {
                fieldValidator.push(Validators.maxLength(inputValidator.maxLength));
              }
            };
            formObj[field.formControlName] = [(this.savedMessage ? this.savedMessage[field.formControlName] : ''), fieldValidator];

            // dropdown under the radio selection
            if (field.dropDownFormControlName) {
              formObj['allCtnSelectedFan'] = [this.allCtnSelectedFan, this.validateAllCtnDropDown];
              formObj['ctnSelectedFan'] = [this.ctnSelectedFan, this.validateCtnDropDown];
            }
          });

          this.messageForm = this.fb.group(formObj);
          this.getAllFan();

          if(this.fanList && this.fanList.length>0){
            this.fanList = this.fanList.filter((value, index, self) =>
            index === self.findIndex((item) => (
              item.name === value.name
            ))
          )
          }
          
          // Validate form on change of radio input
          this.messageForm.controls['accountType'].valueChanges.subscribe((value) => {
            this.messageForm.controls['allCtnSelectedFan'].updateValueAndValidity();
            this.messageForm.controls['ctnSelectedFan'].updateValueAndValidity();
          });
       // }
    
        err => {
          this.showErrorPage();
        };
      //}
    //});
  }
  ngOnInit() {
    this.messageService.createPageLoadProperties('MESSAGE', 'Message');
  }

  next() {
    this.adobeAnalyticsService.createAdobeEventProperties('SMS', 'SUCCESS', 'formSubmit',
    'BC_Device_SMS_Select_Account_Submit', 'success', 'Success_Admit', 'continue', 'Body', '/businessconsole/sendMessage/accounts');
    document.title = this.utilityService.getPageTitleConfig()[this.router.routerState.snapshot.url];
    const previousSelectedFan = this.savedMessage.selectedFan ? this.savedMessage.selectedFan.fanId : '';
    const previousAccountType = this.savedMessage.accountType;
    this.savedMessage.message = this.messageForm.value.message;
    this.savedMessage.accountType = this.messageForm.value.accountType;
    if (this.savedMessage.accountType !== 'allFans') {
      if (this.showDropdown) {
        this.savedMessage.selectedFan = this.savedMessage.accountType === 'allCTN' ?
          this.allCtnSelectedFan.value : this.ctnSelectedFan.value;
      } else {
        this.savedMessage.selectedFan = this.savedMessage.accountType === 'allCTN' ? this.allCtnSelectedFan : this.ctnSelectedFan;
      }
    }
    if ((this.savedMessage.selectedFan && previousSelectedFan !== this.savedMessage.selectedFan.fanId) ||
      (this.savedMessage.accountType !== previousAccountType)) {
      // reset the ctn list on change
      this.savedMessage.ctnList = undefined;
    }
    this.messageService.setMessageModel(this.savedMessage);
    // Adobe Analytics Success Type Starts
    this.adobeAnalyticsService.createAdobeEventProperties('SMS', 'SUCCESS', 'formResponse',
    'BC_Device_SMS_Select_Account_Submit', 'success', 'Success_Admit', 'continue', 'Body', '/businessconsole/sendMessage/accounts');
    // Ends
    this.router.navigate(['accounts'], { relativeTo: this.route.parent });
  }

  back() {
    this.breadcrumb.removeLastBreadCrumb();
    const currentUrl = this.breadcrumb.getLastUrlFromBreadCrumb().routerLink;
    this.router.navigate([currentUrl]);
  }

  getAllFan() {
    this.savedMessage = this.messageService.getMessageModel();

    if (!this.savedMessage.fanList.length) {
      const demoCompany = sessionStorage.getItem('democompany');
      const companyId = demoCompany ? parseInt(demoCompany) : 1;

      this.messageService.getFANList(companyId).subscribe(resObj2 => {
        this.savedMessage.fanList = resObj2.revisedFanList.filter(fan => {
          if (fan.accountStatus === 'ACTIVE' && fan.participationDate && new Date(fan.participationDate) < new Date()) {
            return fan;
          }
        });
        if (this.savedMessage.fanList.length) {
          this.messageService.setMessageModel(this.savedMessage);
          this.createFanSelectOption();
        } else {
          this.showErrorPage();
        }
      }, err => {
        this.showErrorPage();
      });
    } else {
      this.createFanSelectOption();
    }
  }

  selectFan(dropDownSelect: DropdownModel, accountType) {
    if (accountType === 'allCTN') {
      this.allCtnSelectedFan = dropDownSelect;
    } else if (accountType === 'CTN') {
      this.ctnSelectedFan = dropDownSelect;
    }
   
  }

  createDropDownOptions(name, value): DropdownModel {
    const dropDown = {
      'name': name,
      'value': value
    };
    return dropDown;
  }

  validateAllCtnDropDown = (fc) => {
    this.showError = false;
    this.fanNumber = new FormControl();
    const accountType = this.messageForm ? this.messageForm.controls.accountType.value : '';
    if (accountType === 'allCTN' && !fc.value) {
      return {
        valid: false
      };
    }
    return null;
  }

  validateCtnDropDown = (fc) => {
    this.showError = false;
    this.fanNumber = new FormControl();
    const accountType = this.messageForm ? this.messageForm.controls.accountType.value : '';
    if (accountType === 'CTN' && !fc.value) {
      return {
        valid: false
      };
    }
    return null;
  }

  createFanSelectOption() {
    this.spinner.setPageLoaderStatus(true);
    this.fanList = new Array();
    const preSelectValue = this.utilities.getSelectedFan();
    this.utilities.setSelectedFan('');
    const selectedFan = this.savedMessage.selectedFan;
    const accountType = this.savedMessage.accountType;
    let dropdown;
    this.showDropdown = this.savedMessage.fanList.length > 15 ? false : true;
    if (selectedFan) {
      if (this.showDropdown) {
        dropdown = this.createDropDownOptions(selectedFan.fanId, selectedFan);
      }
      if (accountType === 'allCTN') {
        this.allCtnSelectedFan = this.showDropdown ? dropdown : selectedFan;
      } else if (accountType === 'CTN') {
        this.ctnSelectedFan = this.showDropdown ? dropdown : selectedFan;
      }
    }
    this.savedMessage.fanList.filter(fan => {
      let dropdownOption;
      if (this.showDropdown) {
        dropdownOption = this.createDropDownOptions(fan.fanId, fan);
        this.fanList.push(dropdownOption);
      }
      if(this.fanList && this.fanList.length>0){
        this.fanList = this.fanList.filter((value, index, self) =>
        index === self.findIndex((item) => (
          item.name === value.name
        ))
      )
      }
      
      if (preSelectValue && preSelectValue === fan.fanId) {
        this.preselectValue = this.showDropdown ? dropdownOption : fan;
        this.allCtnSelectedFan = this.preselectValue;
        this.ctnSelectedFan = this.preselectValue;
      }
    });

    // Change the form controls too
    this.messageForm.controls['allCtnSelectedFan'].setValue(this.allCtnSelectedFan);
    this.messageForm.controls['ctnSelectedFan'].setValue(this.ctnSelectedFan);

  }

  filter(formControl: string, searchString: string) {
    let searchResult;
    this.showError = false;
    this.savedMessage.fanList.forEach(fan => {
      if (fan.fanId === searchString) {
        searchResult = fan;
      }
    });
    if (formControl === 'allCtnSelectedFan') {
      this.allCtnSelectedFan = searchResult;
    } else {
      this.ctnSelectedFan = searchResult;
    }
    if (searchResult) {
      this.messageForm.controls[formControl].setValue(searchResult);
      this.fanNumber = new FormControl();
    } else {
      this.showError = true;
    }
   
  }

  edit(formControl: string) {
    this.messageForm.controls[formControl].setValue('');
  }

  showErrorPage() {
    this.spinner.setPageLoaderStatus(true);
    this.disableNext = true;
    this.messageService.setPageError(this.pageJson.error);
  }
}
